<div class="asiento-summary">
  <div class="summary-card">
    <div class="summary-row">
      <div class="summary-label">{{ t(label.TOTAL_DEBIT) }}:</div>
      <div
        class="summary-value"
        [class.text-success]="isBalanceado() && totalDebito() > 0"
        [class.text-muted]="totalDebito() === 0"
        [class.text-error]="!isBalanceado() && totalDebito() > 0"
      >
        {{ totalDebito() | number: '1.2-2' }}
      </div>
    </div>
    <div class="summary-row">
      <div class="summary-label">{{ t(label.TOTAL_CREDIT) }}:</div>
      <div
        class="summary-value"
        [class.text-success]="isBalanceado() && totalCredito() > 0"
        [class.text-muted]="totalCredito() === 0"
        [class.text-error]="!isBalanceado() && totalCredito() > 0"
      >
        {{ totalCredito() | number: '1.2-2' }}
      </div>
    </div>
    <div class="summary-row difference" [class.balance]="isBalanceado()">
      <div class="summary-label">{{ t(label.DIFFERENCE_DEBIT_CREDIT) }}:</div>
      <div
        class="summary-value"
        [class.text-success]="isBalanceado()"
        [class.text-warning]="!isBalanceado() && diferencia() > 0"
        [class.text-error]="!isBalanceado() && diferencia() < 0"
      >
        {{ diferencia() | number: '1.2-2' }}
        @if (!isBalanceado()) {
          <span class="balance-status">({{ t(label.NOT_BALANCED) }})</span>
        } @else {
          <span class="balance-status success">✓ {{ t(label.BALANCED) }}</span>
        }
      </div>
    </div>
  </div>
</div>
